import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-manage-templates-contact-admins',
	templateUrl: './manage-templates-contact-admins.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ManageTemplatesContactAdminsComponent {
	public ICON = ICON;

	constructor(
		private dialogRef: MatDialogRef<ManageTemplatesContactAdminsComponent>,
	) {}

	public close() {
		this.dialogRef.close();
	}
}
